import React from 'react';
import { SingleVehicleType } from '../../Components/Types';
import {
    Icon,
    IconContainer,
    IconWrapper,
    Item,
    ItemBody,
} from './DimensionsComponents';

type DimensionsProps = {
    vehicle: SingleVehicleType;
};

function Dimensions({ vehicle }: DimensionsProps) {
    return (
        <IconContainer>
            <Item>
                <IconWrapper>
                    <Icon src="/images/motorhome/dimensions/van_blue.svg" />
                </IconWrapper>
                <ItemBody>
                    <p>L: {vehicle.length}mm</p>
                    <p>W: {vehicle.width}mm</p>
                    <p>H: {vehicle.height}mm</p>
                </ItemBody>
            </Item>
            <Item>
                <IconWrapper>
                    <Icon src="/images/motorhome/dimensions/seats_blue.svg" />
                </IconWrapper>
                <ItemBody>
                    <p>{vehicle.belt} belts</p>
                </ItemBody>
            </Item>
            <Item>
                <IconWrapper>
                    <Icon src="/images/motorhome/dimensions/berth.svg" />
                </IconWrapper>
                <ItemBody>
                    <p>{vehicle.berth} berth</p>
                </ItemBody>
            </Item>
            {vehicle.has_electric_hookup ? (
                <Item>
                    <IconWrapper>
                        <Icon src="/images/motorhome/dimensions/electric.png" />
                    </IconWrapper>
                    <ItemBody>
                        <p>Electric Hook-up</p>
                    </ItemBody>
                </Item>
            ) : (
                ''
            )}
            {vehicle.has_bike_rack ? (
                <Item>
                    <IconWrapper>
                        <Icon src="/images/motorhome/dimensions/bikerack.png" />
                    </IconWrapper>
                    <ItemBody>
                        <p>4 Bike Rack</p>
                    </ItemBody>
                </Item>
            ) : (
                ''
            )}
        </IconContainer>
    );
}
export default Dimensions;
